import React from "react";
import { Box, Typography, Button, Divider } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import CardTypography from "../Typography/CardTypography";

import Chip from "../misc/Chip";

const CommunicationCard = ({ customer_communication, callback_editcommunication }) => {
  const neumorphicStyles = {
    boxShadow: "7px 7px 15px rgba(0, 0, 0, 0.2), -7px -7px 15px rgba(255, 255, 255, 0.5)",
    borderRadius: "15px",
    background: "#e0e0e0",
    padding: "20px",
    margin: "20px 0",
    maxWidth: "400px",
  };

  const statusIcon = (status) => (status ? <CheckCircleIcon color="success" sx={{ marginRight: 1 }} /> : <CancelIcon color="error" sx={{ marginRight: 1 }} />);

  const click_editcommunication = ({ customer_uuid }) => {
    callback_editcommunication({ customer_uuid });
  };

  return (
    <Box sx={neumorphicStyles}>
      <CardTypography variant="h4" sx={{ marginBottom: 2 }}>
        Communication Preference
      </CardTypography>
      <Divider sx={{ marginBottom: 2 }} />
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}>
        {statusIcon(customer_communication.communication_landlord)}
        <CardTypography variant="h6">Customer Channel</CardTypography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}>
        {statusIcon(customer_communication.communication_representative)}
        <CardTypography variant="h6">Representative Channel</CardTypography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        {customer_communication.communication_landlord || customer_communication.communication_representative ? <CheckCircleIcon color="success" sx={{ marginRight: 1 }} /> : <CancelIcon color="error" sx={{ marginRight: 1 }} />}
        <Chip label={customer_communication.communication_verified ? "Verified" : "Unverified"} verified={customer_communication.communication_verified} />
      </Box>

      <Button
        variant="contained"
        onClick={() => click_editcommunication({ customer_uuid: customer_communication.customer_uuid })}
        sx={{
          marginTop: 2,
          background: "#e0e0e0",
          color: "#333",
          boxShadow: "4px 4px 8px rgba(0, 0, 0, 0.2), -4px -4px 8px rgba(255, 255, 255, 0.5)",
          "&:hover": {
            background: "#f0f0f0",
            boxShadow: "inset 2px 2px 5px rgba(0, 0, 0, 0.1), inset -2px -2px 5px rgba(255, 255, 255, 0.5)",
          },
        }}
      >
        Edit
      </Button>
    </Box>
  );
};

export default CommunicationCard;
